import { render } from "./DrillEvaluateView.vue?vue&type=template&id=72b81554&scoped=true"
import script from "./DrillEvaluateView.vue?vue&type=script&lang=js"
export * from "./DrillEvaluateView.vue?vue&type=script&lang=js"

import "./DrillEvaluateView.vue?vue&type=style&index=0&id=72b81554&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b81554"]])

export default __exports__